import { makeStyles } from "tss-react/mui";

const useLoginStyles = makeStyles()((theme) => ({
  errorText: {
    textAlign: "center",
  },
  root: {
    display: "flex",
    flexDirection: "column",
  },
  spacing: {
    paddingBottom: theme.spacing(2),
  },
  spacing05: {
    paddingBottom: theme.spacing(1.5),
  },
  password: {
    marginTop: theme.spacing(3),
    fontSize: "0.85rem",
  },
  submitButton: {
    " > button": {
      fontWeight: "400",
    },
  },
}));
export default useLoginStyles;
